import { useMemo, useState } from 'react';
import { profileService } from 'shared/services/profileService';
import { talentService } from 'shared/services/talentService';
import { mediaService } from 'shared/services/mediaService';

const { getMediaProfile, getSingleProfileGraphQL, getSingleProfile, getProfileTabDetail } = profileService();
const { getStatistics, getGeneral } = talentService();
const { getMediaList } = mediaService();

export const useEditProfileCompositeCardData = (profileId: string) => {
  const { data: generalData, isLoading: isGeneralLoading } = getGeneral();
  const { data: statisticsData, isLoading: isStatisticsLoading } = getStatistics();
  const { data: profileData, isLoading: profileLoading } = getSingleProfileGraphQL(profileId);
  const { data: compositeCardData, isLoading: isLoadingCompositeCardData } = getProfileTabDetail(
    profileId,
    'composite_card',
  );

  const sizeGeneralCombined = () => {
    //combine general and statistics flat map
    const general = generalData?.data.attributes.general;
    const statistics = statisticsData?.data.attributes.statistics;
    const combined = { ...statistics, ...general };
    return combined;
  };

  const talentInfoParsed = () => {
    //using composite_card.info to map over sizeGeneralCombined returning the key value pairs
    const info = compositeCardData?.data.attributes.composite_card?.info;
    const combined: any = sizeGeneralCombined();

    if (!info) return [];
    return info.map((item) => {
      return {
        key: item.value,
        value: combined[item.key],
      };
    });
  };

  const finalTalentInfo = () => {
    const stageName = profileInfo?.talent.stage_name;
    const isNonRepre = profileInfo?.representation_type !== 'agency_representation';
    return {
      name: stageName,
      agencyInfo: isNonRepre
        ? null
        : {
            name: profileInfo?.agency?.name,
            email: profileInfo?.agency?.email,
            phone: profileInfo?.agency?.contact_number,
          },
      talentInfo: talentInfoParsed(),
      nonRepreInfo: {
        email: profileInfo?.talent?.email || '',
        phone: profileInfo?.talent?.other_phone_numbers[0]?.number || '',
      },
    };
  };

  const profileInfo = useMemo(() => {
    if (profileData) {
      return profileData.data.profile;
    }
    return null;
  }, [profileData]);

  return {
    profileInfo,
    compositeCardData,
    isLoadingCompositeCardData,
    finalTalentInfo,
    getMediaProfile,
    getSingleProfileGraphQL,
    getSingleProfile,
    getProfileTabDetail,
    getStatistics,
    getGeneral,
    getMediaList,
  };
};
